import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
const hasSupabaseConfig = Boolean(supabaseUrl && supabaseAnonKey);

const missingSupabaseConfigMessage =
  'Missing Supabase environment variables. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your .env file.';

if (!hasSupabaseConfig && import.meta.env.DEV) {
  console.warn(
    `${missingSupabaseConfigMessage} Supabase-backed content will render fallback/error states until credentials are configured.`
  );
}

const createMissingSupabaseClient = (): SupabaseClient =>
  new Proxy(
    {},
    {
      get() {
        throw new Error(missingSupabaseConfigMessage);
      },
    }
  ) as SupabaseClient;

export const supabase: SupabaseClient = hasSupabaseConfig
  ? createClient(supabaseUrl, supabaseAnonKey)
  : createMissingSupabaseClient();
